import ContentHeader from '@Components/ContentHeader'
import React, { PropsWithChildren, useContext } from 'react'
import './index.scss'
import { WorkModel } from '@Entities/work/work'
import WorkItemPillSection from '@Components/WorkItemPillSection'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import { ZodFormattedError } from 'zod'
import BackButton from '@Components/Buttons/BackButton'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'
import { observer } from 'mobx-react'
import WorkToOverclaimSubHeader from '@Components/ViewWork/Headers/WorkToOverclaimSubHeader'

interface ViewWorkHeaderProps {
    work: WorkModel
    errors?: ZodFormattedError<WorkModel>
    backText?: string
    showOverclaimLink?: boolean
}

const ViewWorkHeader = ({
    work,
    errors,
    backText,
    showOverclaimLink,
    children,
}: PropsWithChildren<ViewWorkHeaderProps>) => {
    const { rightsholderStore, workStore } = useContext<RootStore>(StoresContext)
    const navigate = useNavigate()

    const onClickCatalogNavigate = () => {
        workStore.destroyViewWork()
        workStore.destroyDraftWork()
        if (work.sesacSelectedPropertyId) {
            navigate(
                Navigation.rightholder.catalog.work(
                    rightsholderStore.currentRightsholderId,
                    work.sesacSelectedPropertyId
                )
            )
        }
    }

    return (
        <div className="view-work-header">
            <ContentHeader
                title={stringEscapeNewlines(work.title)}
                content={
                    <>
                        {work.sesacSelectedPropertyId && (
                            <button className="catalog-link" onClick={onClickCatalogNavigate}>
                                View work in catalog
                            </button>
                        )}
                        <span className="error-field">{errors?.title?._errors?.join(', ')}</span>
                    </>
                }
                navLeft={<BackButton text={backText} />}
                navRight={children}
            >
                <div className="right-subheader-pills">
                    {showOverclaimLink && <WorkToOverclaimSubHeader overclaimHeaderId={work.overclaimHeaderId} />}
                    <WorkItemPillSection work={work} />
                </div>
            </ContentHeader>
        </div>
    )
}

export default observer(ViewWorkHeader)
